import { useParties } from "@/hooks/queries/useParties";
import { usePartyStats } from "@/hooks/queries/usePartyStats";
import type { PartyRoleFilter } from "../parties.constants";

export function usePartiesPageData(filters: { search: string; roleFilter: PartyRoleFilter }) {
  const { data, isLoading } = useParties(filters);
  const { data: stats, isLoading: statsLoading } = usePartyStats();

  return {
    parties: data?.data ?? [],
    total: data?.total ?? 0,
    stats,
    isLoading,
    statsLoading,
  };
}
